import { userService } from "../services";
import config from "../config/config";

export const ImageUpload = {
  fetchImageUpload,
};

async function fetchImageUpload(payload) {
  
  try {
    
    let apiEndpoint = `${config.apiName.fileUpload}`;
    let response = await userService.file(apiEndpoint, payload);
    if (response && response.status == 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}